import { Route, Switch } from 'react-router-dom';

import PageNotFound from '../../components/page-not-found';
import RiskAssessment from '../../components/risk-assessment';
import ThankYou from '../../components/risk-assessment/thank-you';

const RiskAssessmentContainer = () => (
  <Switch>
    <Route exact path='/risk-assessment' component={RiskAssessment} />
    <Route exact path='/risk-assessment/thank-you' component={ThankYou} />
    <Route component={PageNotFound} />
  </Switch>
);

export default RiskAssessmentContainer;
